import React from "react";
import NoImage from "../NoImage/NoImage";

const SideBarList = ({
  setList,
  selectedSet,
  setSelectedSet,
  styleClass,
  imgWidth,
  noImageClass,
}) => {
  return (
    <div className="set_list_container">
      {setList?.map((data) => (
        <button
          className={
            selectedSet !== data.key
              ? ` set_list_item settings-list ${
                  styleClass.padding !== undefined ? styleClass.padding : ""
                } not_selected`
              : ` set_list_item settings-list ${
                  styleClass.padding !== undefined ? styleClass.padding : ""
                } selected_list`
          }
          onClick={() => setSelectedSet(data.key, data)}
        >
          {data?.notActiveImage ? (
            <img
              style={imgWidth}
              src={
                selectedSet === data.key
                  ? data.activeImage
                  : data.notActiveImage
              }
              alt={""}
            />
          ) : (
            <NoImage
              data={data?.heading?.split(" ")}
              noImageClass={noImageClass.container}
            />
          )}

          <p
            className={
              selectedSet !== data.key
                ? `${styleClass.selectedText} itme_text`
                : `${styleClass.notSelectedTab} itme_text`
            }
          >
            {data.heading}
          </p>
        </button>
      ))}
    </div>
  );
};

export default SideBarList;
